import ProductPageLayout from '@/pages/products/components/ProductPageLayout';

export default function SwordfishPage() {
  return (
    <ProductPageLayout>
      <div className="relative">
        {/* Page background */}
        <div className="fixed inset-0 z-0 pointer-events-none">
          
        </div>

        {/* Content section */}
              <section className="relative z-10 w-full">
                  {/* Background */}
                  <div className="absolute inset-0 z-0 overflow-hidden">
                      <img
                          src="/images/k2.png"
                          alt="Slide7"
                          className="w-full h-full object-cover object-center blur-md scale-105"
                      />


                      <div className="absolute inset-0 bg-black/50"></div>
                  </div>

          <div className="relative z-10 w-full max-w-[980px] mx-auto px-6 md:px-10 py-10">
            {/* Script tagline */}
            <p className="font-script text-white text-lg md:text-xl text-center mb-4">
              America&#39;s One-Stop-Shop for Seafood
            </p>

            {/* H1 + Header Image */}
            <div className="flex flex-col md:flex-row items-start justify-between gap-4 md:gap-8 mb-2">
              <h1 className="font-heading text-white text-5xl md:text-6xl lg:text-7xl tracking-[0.2em] leading-none uppercase">
                Wholesale<br />Swordfish
              </h1>
              <div className="flex-shrink-0">
                <img
                                  src="/images/po6.png"
                  alt="Product Sword Header"
                  className="w-[600px] max-w-full h-auto"
                />
              </div>
            </div>

            {/* Subheading */}
            <h5 className="font-heading text-white text-lg md:text-xl tracking-[0.15em] leading-snug mb-6 uppercase">
              Wholesale Swordfish<br />from Finest Kind Seafood LLC
            </h5>

            {/* First paragraph - font_7 equivalent */}
            <p className="text-white text-sm leading-relaxed mb-6">
              An FKS signature product, our wholesale swordfish is sourced locally as often as possible from the best fishermen in the North Atlantic swordfish fleet. Our buyers were fisherman themselves for decades of combined experience before entering the wholesale distribution side of the seafood industry – making them experts at knowing their product and where to buy it from. In fact, FKS has even owned two of our own longline fishing vessels in the past that we continue to buy from today: F/V Iron Maiden and F/V Iron Lady. As such, we maintain our strong, personal relationships with industry leading local, longline fishing vessels – which fish from the Gulf of Mexico to the Grand Banks off Newfoundland depending on the season – and recognize these relationships as a major key to our continued success.
            </p>

            {/* Content with zoom image */}
            <div className="relative">
              <img
                              src="/images/po7.png"
                alt="Wholesale Swordfish Zoom"
                className="float-right ml-6 mb-4 w-[280px] md:w-[466px] h-auto"
              />
              <p className="text-white text-[13px] leading-relaxed mb-5">
                Although we always strive to source our wholesale swordfish locally, the high volumes of product we go through sometimes require us to adapt to the market and source product elsewhere from around the world. Not only does volume play a part in the need for us to adapt, but the seasons do as well. Swordfish – being a highly migratory species – typically migrates from warmer waters in the winter (i.e. the Caribbean) to colder waters in the summer (i.e. the Grand Banks) and vice versa. In general, fresh swordfish are most often found in tropical and temperate seas around the world, all depending on the time of year.
              </p>
              <p className="text-white text-[13px] leading-relaxed mb-5">
                With regard to swordfish being a high migratory species, we therefore respond by purchasing our product from wherever the best quality is currently residing. For instance, because of the fact that cold waters generally produce better quality swordfish than warm waters, we source a lot of our swordfish from Australia during their winter season. In addition, we also purchase our wholesale swordfish from the long-line fleet that operates out of Hawaii, several areas in South Africa, and many other parts of the world.
              </p>
              <p className="text-white text-[13px] leading-relaxed mb-5">
                Although FKS swordfish is available year round, the market peaks during the fall when the local fisheries are in full swing and we also have quality imports coming in from around the world. We&#39;re stocked with ample supply of the best quality swordfish we see all year during this time, yet prices are generally at their low point due to supply over extending demand, making it an excellent time to promote swordfish. You&#39;ll get both the best quality and best prices of the year. These beautiful, ruby-red bloodline swordfish are rich, tender, and full of flavor.
              </p>
              <div className="clear-both" />
            </div>

            {/* Final paragraph - font_7 equivalent */}
            <p className="text-white text-sm leading-relaxed mb-10">
              At Finest Kind Seafood LLC, we understand the key to quality swordfish is properly handling the product and getting it out the door quickly. This is why we only purchase our sword from boats we can trust to handle the product with care like we do – keeping the belly cavities fully stuffed and bodies completely covered with ice – ensuring peek freshness and gorgeous red bloodlines every time the product leaves our doors.
            </p>
          </div>
        </section>
      </div>
    </ProductPageLayout>
  );
}